import { checkIsCountdownPass } from "./methods/checkIsCountdownPass";
import { checkIsDbsCoupon } from "./methods/checkIsDbsCoupon";
import { checkIsLocalUse } from "./methods/checkIsLocalUse";
import { checkIsOldQrPass } from "./methods/checkIsOldQrPass";
import { checkIsQrPass } from "./methods/checkIsQrPass";
import { checkIsQrTicketGate } from "./methods/checkIsQrTicketGate";
import { checkIsValidQrCode } from "./methods/checkIsValidQrCode";
import { getUsePassIndex } from "./methods/getUsePassIndex";

export default {
  checkIsCountdownPass,
  checkIsDbsCoupon,
  checkIsLocalUse,
  checkIsOldQrPass,
  checkIsQrPass,
  checkIsQrTicketGate,
  checkIsValidQrCode,
  getUsePassIndex,
};
